import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import WarningIcon from '@mui/icons-material/Warning';
import moment from 'moment';
import { sort_by_hours } from '../utility/index';
import strings from '../utility/strings.js';

const Hours = (props) => {
  const { loadingLocation, locationDetails } = props;

  if (loadingLocation || locationDetails.normalHours === undefined) {
    // Location details is still loading render skeleton
    return <div className="location-hours warning">
      <div className="location-hours-header">
        <div className="hours-header-title">Hours</div>
        <div className="hours-header-term">
          <Skeleton width="20%" height={25} style={{margin: '0 auto'}}/>
        </div>
      </div>
      <div className="location-hours-section">
        <div className="hours-section-title"><div style={{padding: '.5rem 2rem', width: '50%', margin: '0 auto', border: '1px solid #daaa00'}}><Skeleton width="50%" style={{margin: '0 auto'}} height={40} component="p" /></div></div>
        <div className="location-hours-section-meals">
          <div className="hours-section-row">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="hours-section-row">
            <Skeleton width="100%" height={25} />
          </div>
          <div className="hours-section-row">
            <Skeleton width="100%" height={25}/>
          </div>
        </div>
      </div>
    </div>
  } else if(locationDetails.normalHours !== undefined) {
    let term = locationDetails.normalHours[0] ? locationDetails.normalHours[0] : null;

    if (!term) {
      return (
        <div className="location-hours warning">
          <div className="location-hours-header">
            <div className="hours-header-title">Hours</div>
            <div className="hours-header-term"></div>
          </div>
          <WarningIcon />
          <div className="location-hours-disclaimer">Sorry, our normal hours aren't available right now.</div>
        </div>
      );
    }

    let termName = term.name;
    let week = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    let days = sort_by_hours(term.days, week, 'dayOfWeek');
    let periods = [];

    if (term.days.length === 0 && termName) {
      return (
        <div className="location-hours">
          <div className="location-hours-header">
            <div className="hours-header-title">Hours</div>
            <div className="hours-header-term">{term.Name}</div>
          </div>
          <div key={"locationHours_" + Math.floor(Math.random() * 999999)} className="location-hours-section">
            <div className="hours-section-title"><span>Monday-Sunday</span></div>
            <div className="location-hours-section-meals">
              <div key={"hoursSection_" + Math.floor(Math.random() * 999999)} className="hours-section-row">
                <div className="hours-section-row-label">All Meals</div>
                <div className="hours-section-row-text">Closed</div>
              </div>
            </div>
          </div>
          <div className="location-hours-section">
            <div className="hours-section-disclaimer"><span>{strings.hoursdisclaimer}<br />{strings.hoursdislaimertimezone}</span></div>
          </div>
        </div>
      );
    }


    // move Sunday to the end of the array
    //if (days[0].name === "Sunday") { days.push(days.shift()); }


    days.forEach(function (day, index) {

      let lastPeriod = periods.length > 0 ? periods[periods.length - 1] : null;

      // We have to sort the meals otherwise the strings will not match on compare
      let lastMeals = lastPeriod ? lastPeriod.meals : null;
      let dayMeal = day.meals;

      if (index === 0 || (lastMeals !== null && JSON.stringify(lastMeals) !== JSON.stringify(dayMeal))) {
        periods.push({
          startDay: day.dayOfWeek,
          endDay: day.dayOfWeek,
          meals: day.meals
        });
      } else {
        lastPeriod.endDay = day.dayOfWeek
      }
    });

    let sections;
    if (periods.length > 0) {
      sections = periods.map(function (period) {
        let timeParseFormat = "HH:mm:ss";
        let timeFormat = "h:mma";
        let periodName = period.startDay !== period.endDay ? period.startDay + " - " + period.endDay : period.startDay;

        let meals = period.meals.map(function (meal) {

          let mealName = meal.name;

          let startTime = meal.startTime;
          let startTimeText = startTime ? (new moment.parseZone(startTime, timeParseFormat).format(timeFormat)).slice(0, -1) : null;

          let endTime = meal.endTime;
          let endTimeText = startTime ? (new moment.parseZone(endTime, timeParseFormat).format(timeFormat)).slice(0, -1) : null;

          let rowText = startTime ? <span> {startTimeText} &#8211; {endTimeText} </span> : "Closed";

          return <div key={periodName + "_" + meal.name} className="hours-section-row">
            <div className="hours-section-row-label">{mealName}</div>
            <div className="hours-section-row-text">{rowText}</div>
          </div>
        });

        return <div key={periodName} className="location-hours-section">
          <div className="hours-section-title"><span>{periodName}</span></div>
          <div className="location-hours-section-meals">{meals}</div>
        </div>
      });
    } else {
      sections = (
        <div className="location-hours-section">
          <div className="hours-section-title">{strings.hoursunavailable}</div>
          <div className="location-hours-section-meals"></div>
        </div>
      )
    }

    return (
      <div className="location-hours">
        <div className="location-hours-header">
          <div className="hours-header-title">Hours</div>
          <div className="hours-header-term">{termName}</div>
        </div>

        {sections}

        <div className="location-hours-section">
          <div className="hours-section-disclaimer"><span>{strings.hoursdisclaimer}<br />{strings.hoursdislaimertimezone}</span></div>
        </div>

      </div>
    );
  }
}

export default Hours;